import { Platform } from 'react-native'
import type { Theme } from '../../theme/getTheme'
import { ARENA_WEB_HEADER_CLEARANCE } from '../constants/challenges.constants'

export const getChallengesLayoutStyleSheet = (theme: Theme) => ({
  container: {
    flex: 1,
    paddingTop: 0,
    backgroundColor: theme.background.primary,
    ...(Platform.OS === 'web' && {
      height: '100vh' as never,
      overflow: 'hidden' as never,
      width: '100%',
      maxWidth: '100%',
      overflowX: 'hidden' as never,
      boxSizing: 'border-box' as never,
    }),
  },
  combinedHeader: {
    flexDirection: 'row' as const,
    alignItems: 'center' as const,
    justifyContent: 'space-between' as const,
    paddingHorizontal: 20,
    paddingTop: Platform.OS === 'web' ? 8 : 4,
    paddingBottom: 8,
    backgroundColor: theme.background.primary,
    zIndex: Platform.OS === 'web' ? 10002 : 2,
    minHeight: Platform.OS === 'web' ? 60 : 44,
    position: 'relative' as const,
    gap: 16,
    ...(Platform.OS === 'web' && {
      position: 'absolute' as never,
      top: 0,
      left: 0,
      right: 0,
    }),
  },
  hamburgerMenu: {
    width: 40,
    height: 40,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    borderRadius: 20,
    backgroundColor: 'transparent',
    zIndex: Platform.OS === 'web' ? 10003 : 3,
    pointerEvents: 'box-only' as const,
  },
  hamburgerMenuPressed: {
    opacity: 0.65,
    ...(Platform.OS === 'web' && {
      backgroundColor: theme.gray[300],
      opacity: 1,
    }),
  },
  hamburgerMenuHover: {
    backgroundColor: theme.gray[200],
  },
  challengesListWrapper: {
    flex: 1,
  },
  /**
   * Everything on the Arena tab below the header (Mine|Open toggle + the list itself).
   * On web `combinedHeader` is position:absolute, so it occupies no flow space — this wrapper
   * carries the clearance for the whole body. Without it, the first in-flow child renders at
   * y=0 *behind* the opaque header (that is how the Mine|Open toggle went invisible on web).
   */
  arenaBody: {
    flex: 1,
    ...(Platform.OS === 'web' && { paddingTop: ARENA_WEB_HEADER_CLEARANCE }),
  },
  challengesList: {
    flex: 1,
    // Web clearance lives on `arenaBody` above — keep it here too and it double-counts.
    paddingTop: Platform.OS === 'web' ? 0 : 6,
    paddingHorizontal: 16,
    paddingBottom: 0,
  },
  loadingContainer: {
    flex: 1,
    justifyContent: 'center' as const,
    alignItems: 'center' as const,
    padding: 20,
  },
  loadingText: {
    fontSize: 16,
    fontWeight: '600' as const,
    color: theme.gray[700],
    marginTop: 12,
  },
})
